export class AccessibilityController {

  constructor(private readonly root: ShadowRoot | null) {
  }

  /**
   * Initializes accessibility features by focusing the input field and
   * cleaning the Google Maps DOM once the map becomes idle.
   */
  initAccessibility(map?: google.maps.Map): void {
    if (!this.root || !map) {
      return;
    }
    map.addListener("idle", () => {
      setTimeout(() => this.cleanGoogleMapsDom(), 100);
    });
  }

  /**
   * Corrects the Google Maps DOM by removing unwanted tabstops and hiding
   * advanced markers from the standard tab flow.
   */
  private cleanGoogleMapsDom(): void {
    if (!this.root) {
      return;
    }

    this.root.querySelector('div[aria-roledescription="Karte" i], div[aria-roledescription="Map" i]')
      ?.removeAttribute('tabindex');

    this.root.querySelectorAll('gmp-advanced-marker').forEach(m => {
      if (m.getAttribute('tabindex') !== '-1') {
        m.setAttribute('tabindex', '-1');
      }
    });
  }

  /**
   * Manages spatial navigation (Arrow Up/Down) and Escape
   * logic when a specific search result item has focus.
   */
  handleKeyDown(e: KeyboardEvent, clearInputValue: () => void): void {
    if (!this.root) {
      return;
    }

    const target = e.target as HTMLElement;
    const input = this.root.getElementById("input");

    if (e.key === "Escape") {
      clearInputValue();
      input?.focus();
      return;
    }

    if (!["ArrowDown", "ArrowUp"].includes(e.key)) {
      return;
    }

    e.preventDefault();

    if (target === input && e.key === "ArrowDown") {
      this.root.querySelector<HTMLElement>(".result")?.focus();
      return;
    }

    const next = e.key === "ArrowDown" ? target.nextElementSibling : target.previousElementSibling;
    const end = this.root.querySelector(".closest-stores");

    if (next instanceof HTMLElement && next !== end) {
      next.focus();
    } else if (e.key === "ArrowUp") {
      input?.focus();
    }
  }
}